export const DefaultCraPlayerOptions = {
  plugins: {},
  autoplay: false,
  controls: true,
  preload: 'auto',
  enableSmoothSeeking: true,
  fluid: true
}
